import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/BecauseYouShopped/GET';

export const BECAUSE_YOU_SHOPPED_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const BECAUSE_YOU_SHOPPED_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
